import React from 'react';
import PropTypes from 'prop-types';
import EstimotoSymbol from '../../images/esitmoto-symbol.png';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

const NoOffers = ({ whichFolder, t, }) => {
  const noOffersDescription = t(`${whichFolder}_description`);
  return (
    <tr className="no-offer-container">
      <td colSpan="100%">
        <img src={EstimotoSymbol} alt="Estimoto" className="no-offer-image" />
        <span className="no-offer-description">{noOffersDescription}</span>
      </td>
      <style jsx="true">{`
        .no-offer-container {
          cursor: default;
          text-align: center;
        }
        .no-offer-image {
          max-height: 100px;
          margin: 60px 0 25px 0;
        }
        .no-offer-description {
          display: block;
          font-size: 16px;
          color: #d4d3d6;
          font-weight: 700;
        }
      `}</style>
    </tr>
  );
};

NoOffers.propTypes = {
  t: PropTypes.func.isRequired,
  whichFolder: PropTypes.string.isRequired,
};


export default withScopedTranslations('no_offers')(NoOffers);
